module.exports = __webpack_public_path__ + "img/tor-birdy.png";